import { render } from "./bmTopicCheck.vue?vue&type=template&id=5bec419c&scoped=true"
import script from "./bmTopicCheck.vue?vue&type=script&lang=js"
export * from "./bmTopicCheck.vue?vue&type=script&lang=js"

import "./bmTopicCheck.vue?vue&type=style&index=0&id=5bec419c&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bec419c"]])

export default __exports__